import dayjs from 'dayjs'

const defaultState = () => {
	return {
		isActive: false,
		start: '2025-10-31T14:00:00Z',
		end: '2025-11-02T23:59:59Z',
		day1Start: '2025-10-31T14:00:00Z',
		day2Start: '2025-11-01T14:00:00Z',
		day3Start: '2025-11-02T15:00:00Z',
	}
}

export const state = () => defaultState()

export const mutations = {
	setIsWfActive(state, isWfActive) {
		state.isActive = isWfActive
	},
}

export const actions = {}

export const getters = {
	wfStartDate(state) {
		return state.start
	},
	wfDay1Start(state) {
		return state.day1Start
	},
	wfDay2Start(state) {
		return state.day2Start
	},
	wfDay3Start(state) {
		return state.day3Start
	},
	wfEndDate(state) {
		return state.end
	},
	isWfActive(state) {
		return !!state.isActive
	},
	isWfBefore(state) {
		return !!state.isActive && dayjs().isBefore(state.start)
	},
	isWfLive(state) {
		return (
			!!state.isActive &&
			dayjs().isSameOrAfter(state.start) &&
			dayjs().isSameOrBefore(state.end)
		)
	},
}
